export default "__VITE_ASSET__CDCzpoW9__"